/**
 * Groessen-Kaskade der Kategorie-Vorwahl (sections/collection-prefilter.liquid).
 *
 * Frueher ein ~8,4-kB-Inline-Block, der zur Parse-Zeit mitten im Body lief und
 * auf jeder Kollisions-/Suchseite neu uebertragen wurde. Als Asset mit defer:
 * cachebar, laeuft nach dem DOM-Aufbau, gleiche Semantik (apReady-Guard
 * verhindert Doppel-Init, window.__apSizeTrees dedupliziert den Proxy-Abruf).
 * Der Platzhaltertext kommt als data-placeholder vom Formular.
 * Der Regressionstest tests/collection-prefilter.test.js laedt DIESE Datei.
 */
(function () {
  var form = document.querySelector('[data-ap-size-finder]');
  if (!form || form.dataset.apReady) return;
  form.dataset.apReady = '1';

  var selW = form.querySelector('[data-ap-width]');
  var selA = form.querySelector('[data-ap-aspect]');
  var selD = form.querySelector('[data-ap-diameter]');
  var go = form.querySelector('.ap-prefilter__size-go');
  var season = form.getAttribute('data-season') || '';
  var vehicleType = form.getAttribute('data-vehicle-type') || '';
  // Zoll, auf den diese Seite bereits eingegrenzt ist (Split-Kind wie "Sommerreifen
  // 17 Zoll"). Kommt aus dem subnav-Metafeld, wo die App ihn REGELBASIERT ableitet —
  // die Verengung kann von einem Vorfahren stammen und steht dann in keinem Seitentitel.
  var pinnedDia = form.getAttribute('data-rim-diameter') || '';
  // Die Einschraenkung DIESER Seite, die die Kaskade selbst nicht nachbildet (Flanken-
  // kennung, Werksfreigabe, Marke …) — fertig kodierte Filterparameter, die die App in
  // extraFilterParams baut und mit '&' verbunden durchreicht. Ohne sie ging genau diese
  // Einschraenkung beim Absenden verloren: auf xl-reifen-extra-load-17-zoll waehlte der
  // Kunde eine Groesse und bekam Nicht-XL-Reifen.
  var extraFilters = (form.getAttribute('data-extra-filters') || '').split('&').filter(Boolean);
  // Ziel der TAG-ROUTE dieser Seite (Kollektions-URL; auf der Sammelroute
  // /collections/all). Der eigentliche Groessen-Tag kommt NIE von hier: er ist die
  // verbatim gedruckte Groesse und steht als Handle-Form im Baum (tags) — das Theme
  // einen Tag raten zu lassen hiesse, auf eine Ansicht ohne Mitglieder zu springen,
  // die ohne jede Fehlermeldung als nackte Liste rendert.
  var tagBase = form.getAttribute('data-tag-base') || '';
  var PICK = form.getAttribute('data-placeholder') || '–';
  // Querschnitt-Schluessel fuer Groessen OHNE Querschnitt (16.9R30, 11.2-24, 185R14C).
  // WOERTLICHER Vertrag mit NO_ASPECT_KEY in app/lib/catalog/available-sizes.server.ts:
  // der Baum traegt ihn nur mit na=1, und immer als LETZTEN Querschnitt einer Breite.
  var NO_ASPECT = '-';
  // "keine Angabe" statt "ohne Querschnitt": die Trefferliste wird bei dieser Wahl
  // BREITER, nicht enger — Search & Discovery kennt kein "Metafeld fehlt", der
  // aspect_ratio-Filter entfaellt dann einfach. Gemessen 2026-09-01 auf
  // /collections/28-zoll: width=16.9 trifft 29, davon traegt genau einer 16.9/14.
  // Ein Label wie "ohne Querschnitt" verspraeche eine Einschraenkung, die nicht kommt.
  // Fest verdrahtet statt als Section-Einstellung: dieselbe Zeichenkette steht im
  // App-Block extensions/tyre-search, und derselbe Reifen darf im Shop nicht zwei
  // Namen haben.
  var NO_ASPECT_LABEL = '– (keine Angabe)';

  /* AUSWAHLLISTEN BEI BEDARF (P1 M6, PD-11) wie <tyre-size-search> in automotive.js (eigene Kopie): im Ruhezustand nur
     Platzhalter und gesetzter Wert, voll bei focus/pointerdown/mousedown/touchstart/keydown und fuer Skripte. */
  var AUSWAHL_BEDARF = ['focus', 'pointerdown', 'mousedown', 'touchstart', 'keydown'];

  function auswahlEigenschaft(name) {
    var p = typeof HTMLSelectElement === 'function' ? HTMLSelectElement.prototype : null;
    while (p) {
      var d = Object.getOwnPropertyDescriptor(p, name);
      if (d) return d;
      p = Object.getPrototypeOf(p);
    }
    return null;
  }

  function auswahlWert(sel) {
    var d = auswahlEigenschaft('value');
    return d && d.get ? d.get.call(sel) : sel.value;
  }

  function auswahlZeichnen(sel, voll, aktuell) {
    var liste = sel.__apListe;
    if (!liste) return;
    var hat = liste.eintraege.some(function (e) { return e.wert === aktuell; });
    sel.innerHTML = '';
    if (liste.kopf) {
      var opt = document.createElement('option');
      opt.value = '';
      opt.textContent = liste.kopf;
      sel.appendChild(opt);
    }
    var wahl = liste.kopf ? '' : null;
    liste.eintraege.forEach(function (e, i) {
      var gewaehlt = hat ? e.wert === aktuell : !liste.kopf && i === 0;
      if (!voll && !gewaehlt) return;
      var o = document.createElement('option');
      o.value = e.wert;
      o.textContent = e.text;
      if (gewaehlt) {
        o.selected = true;
        wahl = e.wert;
      }
      sel.appendChild(o);
    });
    // Den Wert ausdruecklich setzen: nach innerHTML = '' haelt nicht jede Umgebung die Auswahl ueber selected.
    var dv = auswahlEigenschaft('value');
    if (wahl !== null && dv && dv.set) dv.set.call(sel, wahl);
    sel.__apVoll = !!voll;
  }

  function auswahlVoll(sel) {
    if (!sel.__apListe || sel.__apVoll) return;
    auswahlZeichnen(sel, true, auswahlWert(sel));
  }

  function auswahlBedarf(sel) {
    if (sel.__apBedarf) return;
    sel.__apBedarf = true;
    var voll = function () { auswahlVoll(sel); };
    AUSWAHL_BEDARF.forEach(function (t) {
      sel.addEventListener(t, voll, { capture: true, passive: true });
    });
    ['options', 'selectedIndex', 'length'].forEach(function (name) {
      var d = auswahlEigenschaft(name);
      if (!d || !d.get) return;
      var eigen = { configurable: true, get: function () { voll(); return d.get.call(sel); } };
      if (d.set) eigen.set = function (v) { voll(); d.set.call(sel, v); };
      Object.defineProperty(sel, name, eigen);
    });
    var dv = auswahlEigenschaft('value');
    if (dv && dv.get && dv.set) {
      Object.defineProperty(sel, 'value', {
        configurable: true,
        get: function () { return dv.get.call(sel); },
        set: function (v) {
          if (!sel.__apVoll && String(v) !== '' && String(v) !== dv.get.call(sel)) voll();
          dv.set.call(sel, v);
        }
      });
    }
  }

  // `noPlaceholder` laesst die "–"-Option weg: dann traegt das Feld nur echte Werte und
  // kann nicht auf leer zurueckgestellt werden. Genutzt fuer das festgenagelte Zoll-Feld.
  function fill(sel, values, placeholder, noPlaceholder) {
    var aktuell = auswahlWert(sel);
    var warVoll = !!sel.__apVoll;
    sel.__apListe = {
      kopf: noPlaceholder ? null : placeholder,
      eintraege: values.map(function (v) {
        // Der Platzhalter-Schluessel bekommt eine Beschriftung statt eines nackten "-".
        // Nur das Querschnitt-Feld kann ihn tragen: Breiten kommen als Zahlen vom Proxy,
        // und ein Zoll-Schluessel "-" existiert im Baum nicht.
        return { wert: String(v), text: String(v) === NO_ASPECT ? NO_ASPECT_LABEL : String(v) };
      })
    };
    var kompaktMoeglich = !!auswahlEigenschaft('options') && !!auswahlEigenschaft('value');
    auswahlZeichnen(sel, !kompaktMoeglich || warVoll || document.activeElement === sel, aktuell);
    if (kompaktMoeglich) auswahlBedarf(sel);
  }

  // Erklaerung, warum das Zoll-Feld nur eine Auswahl hat — als vorgelesener Text am Feld.
  // Frueher war das Feld schlicht disabled: damit fiel es aus der Tabreihenfolge, und
  // weder Tastatur- noch Screenreader-Nutzer erfuhren, dass die Kategorie selbst die
  // Zollgroesse vorgibt.
  var pinNote = null;
  function describePinned() {
    var tpl = form.getAttribute('data-fixed-note') || '';
    if (!tpl) return;
    if (!pinNote) {
      pinNote = document.createElement('span');
      pinNote.className = 'visually-hidden';
      pinNote.id = (selD.id || 'ap-pref-dia') + '-fixed';
      selD.parentNode.insertBefore(pinNote, selD.nextSibling);
      selD.setAttribute('aria-describedby', pinNote.id);
    }
    pinNote.textContent = tpl.split('[zoll]').join(pinnedDia);
  }

  // Die Saison der Kollektion filtert den Baum: eine Größe, die es hier nicht als
  // Winterreifen gibt, darf gar nicht erst zur Auswahl stehen.
  function leafOk(seasons) {
    if (!season) return true;
    return Array.isArray(seasons) && seasons.indexOf(season) !== -1;
  }
  // Ein Blatt des Baums zählt nur, wenn es auch im Zoll dieser Seite liegt. Die Prüfung
  // gehört hierher und nicht erst ans Zoll-Feld: sonst stünden Breiten und Querschnitte
  // zur Wahl, die es nur in anderen Durchmessern gibt, und der Klick liefe ins Leere.
  function sizeOk(diameter, seasons) {
    if (pinnedDia && String(diameter) !== pinnedDia) return false;
    return leafOk(seasons);
  }
  // Sortiert numerisch, laesst NO_ASPECT aber als ZEICHENKETTE stehen und stellt ihn ans
  // ENDE. Das fruehere .map(Number) machte aus ihm eine Option "NaN" — waehlbar und
  // nirgends hinfuehrend. Dieselbe Regel steht in sortKeys im App-Block
  // extensions/tyre-search und in buildSizeTree (available-sizes.server.ts), das den
  // Schluessel schon beim Bauen zuletzt einsortiert: drei Stellen, eine Reihenfolge.
  function numKeys(obj, keep) {
    var ks = Object.keys(obj || {}).filter(keep);
    var i = ks.indexOf(NO_ASPECT);
    if (i > -1) ks.splice(i, 1);
    ks.sort(function (a, b) { return a - b; });
    if (i > -1) ks.push(NO_ASPECT);
    return ks;
  }

  var tree = null;
  function aspects() {
    var byA = tree && selW.value ? tree.tree[selW.value] : null;
    return byA
      ? numKeys(byA, function (a) {
          return Object.keys(byA[a]).some(function (d) { return sizeOk(d, byA[a][d]); });
        })
      : [];
  }
  function diameters() {
    var byA = tree && selW.value ? tree.tree[selW.value] : null;
    var byD = byA && selA.value ? byA[selA.value] : null;
    return byD ? numKeys(byD, function (d) { return sizeOk(d, byD[d]); }) : [];
  }
  // NUR die Ebenen UNTER der geänderten neu aufbauen. Ein gemeinsames refresh(), das
  // alle drei Felder füllt, löscht die gerade getroffene Auswahl im selben Moment wieder
  // (fill() setzt innerHTML) — das Feld springt auf "–" zurück und die nächste Ebene
  // bleibt für immer gesperrt. Genau so war es live: "Querschnitt nicht wählbar".
  function refreshAspects() {
    var a = aspects();
    fill(selA, a, PICK);
    selA.disabled = !a.length;
  }
  function refreshDiameters() {
    var d = diameters();
    // Auf einer zoll-verengten Seite gibt es genau EINE gültige Wahl. Sie steht als einzige
    // Option im Feld, ohne Platzhalter — verstellen lässt sich damit nichts, aber das Feld
    // bleibt BEDIENBAR: es behält seinen Platz in der Tabreihenfolge und wird mitsamt der
    // Begründung aus data-fixed-note vorgelesen. Ein `disabled` täte beides nicht.
    var pinned = !!pinnedDia && d.length > 0;
    fill(selD, d, PICK, pinned);
    selD.disabled = !d.length;
    if (pinned) {
      selD.value = pinnedDia;
      describePinned();
    }
  }
  function updateGo() {
    go.disabled = !(selW.value && selA.value && selD.value);
  }

  // Gemerkte Groesse — Vertrag: Schluessel "ap_last_size", Wert JSON
  // {"w":..,"h":..,"d":..,"label":"205/55 R16","url":"<facetten-url>"}.
  // Der Zugriff steht bewusst in eigenen try/catch: dieses Skript laeuft
  // beim Parsen, also lange vor automotive.js, und darf dessen Helfer
  // nicht voraussetzen.
  function num(v) {
    var n = Number(v);
    return isFinite(n) ? n : v;
  }
  function readLastSize() {
    var raw = null;
    try { raw = window.localStorage.getItem('ap_last_size'); } catch (e) { return null; }
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) { return null; }
  }
  function writeLastSize(url) {
    // Ohne Querschnitt traegt der Merker ein LEERES h und ein Label ohne Bruchstrich
    // ("16.9 R30", nicht "16.9/- R30"). Wortgleich mit dem App-Block
    // extensions/tyre-search, der denselben Schluessel schreibt — der Chip "Zuletzt
    // gesucht" auf der Startseite zeigt genau dieses Label an. num('-') gaebe sonst die
    // Zeichenkette "-" ins h zurueck (Number('-') ist NaN, num faellt auf den Rohwert).
    var a = selA.value === NO_ASPECT ? '' : selA.value;
    try {
      window.localStorage.setItem('ap_last_size', JSON.stringify({
        w: num(selW.value),
        h: a ? num(a) : '',
        d: num(selD.value),
        label: a ? selW.value + '/' + a + ' R' + selD.value : selW.value + ' R' + selD.value,
        url: url
      }));
    } catch (e) { /* Speicher aus oder voll — die Suche laeuft trotzdem. */ }
  }
  // Nur setzen, was es in DIESER Kategorie wirklich gibt: eine Vorbelegung,
  // die der Saison-/Fahrzeugfilter dieser Seite gar nicht hergibt, fuehrte
  // auf eine leere Liste.
  function preselect(sel, v) {
    if (v === undefined || v === null || v === '') return false;
    var wanted = String(v);
    // Liste bei Bedarf: gegen die gespeicherte Liste pruefen, ohne sie zu zeichnen (P1 Massnahme 6).
    if (sel.__apListe) {
      var hat = sel.__apListe.eintraege.some(function (e) { return e.wert === wanted; });
      if (!hat) return false;
      if (sel.__apVoll) sel.value = wanted;
      else auswahlZeichnen(sel, false, wanted);
      return true;
    }
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === wanted) { sel.value = wanted; return true; }
    }
    return false;
  }
  function applyLastSize() {
    var last = readLastSize();
    if (!last) return;
    if (!preselect(selW, last.w)) return;
    refreshAspects();
    // Das leere h aus writeLastSize IST der Querschnitt-Platzhalter. Ohne diese
    // Ruecknahme schriebe der Merker einen Zustand, den er nie wieder liest: preselect
    // faellt bei '' sofort durch, und die gemerkte Groesse waere fuer genau die Reifen
    // tot, fuer die dieser Umbau da ist. Ein FEHLENDES h bleibt ein Abbruch — nur der
    // leere String ist das ausdrueckliche "hat keinen Querschnitt".
    if (!preselect(selA, last.h === '' ? NO_ASPECT : last.h)) return;
    refreshDiameters();
    preselect(selD, last.d);
  }

  selW.addEventListener('change', function () {
    refreshAspects();
    refreshDiameters();
    updateGo();
  });
  selA.addEventListener('change', function () {
    refreshDiameters();
    updateGo();
  });
  selD.addEventListener('change', updateGo);

  // ZIEL: die Suchergebnis-Seite mit den tyre.*-Metafeldfiltern — NICHT eine
  // zusammengebaute Größen-Tag-URL. Der Größen-Tag auf dem Produkt ist die VERBATIM
  // gedruckte Größe (C-Kennung "185R14C", ZR-Bauart, x-Notation, siehe size-label.ts)
  // und lässt sich aus Breite/Querschnitt/Zoll nicht zuverlässig rekonstruieren — jeder
  // Fehlgriff landet auf einer leeren Seite. Die numerischen Metafelder dagegen sind
  // exakt die Werte, die auch in der Kaskade stehen. Saison und Fahrzeugklasse der Seite
  // fahren als Filter mit, damit der Kategorie-Kontext erhalten bleibt; die Trefferzahl
  // einer konkreten Größe liegt weit unter Shopifys 1.000er-Grenze, dort rendern die
  // Filter also auch.
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!selW.value || !selA.value || !selD.value) return;
    // Auf DIESER Kollektion filtern, wenn sie klein genug ist (data-coll wird nur
    // unter 5.000 Produkten gesetzt) — /search wendet die Facetten oberhalb von
    // 1.000 Treffern nicht verlaesslich an, q=reifen trifft ~55.000. Gemessen
    // 2026-08-20: /search fand 0, die Kollektion 1. Siehe tyreFacetUrl in
    // automotive.js. Ohne Ziel bleibt /search — unvollstaendig, aber besser als
    // nichts. Die Produktart entfaellt dann, sie steckt schon in der Kollektion.
    var coll = form.getAttribute('data-coll');
    var p = [];
    if (!coll) p.push('q=reifen', 'options%5Bprefix%5D=last');
    // Bei NO_ASPECT faellt der Querschnitt ERSATZLOS weg, statt als "aspect_ratio=-"
    // mitzufahren: so ein Reifen traegt das Metafeld gar nicht, und ein Filter darauf
    // liefert eine garantiert leere Liste MIT aktivem Filter-Chip — die unangenehmste
    // Fehlerart, die Seite sieht funktionierend aus. Live gemessen 2026-09-01 auf
    // /collections/30-zoll: width=16.9 -> 28 Treffer, dieselbe URL zusaetzlich mit
    // aspect_ratio=70 -> 0.
    var aspect = selA.value === NO_ASPECT ? '' : selA.value;
    p.push('filter.p.m.tyre.width=' + encodeURIComponent(selW.value));
    if (aspect) p.push('filter.p.m.tyre.aspect_ratio=' + encodeURIComponent(aspect));
    p.push('filter.p.m.tyre.rim_diameter=' + encodeURIComponent(selD.value));
    if (season) p.push('filter.p.m.tyre.season=' + encodeURIComponent(season));
    if (vehicleType && !coll) p.push('filter.p.product_type=' + encodeURIComponent(vehicleType));
    // Die Einschraenkung der Seite mitnehmen — auf BEIDEN Wegen und ohne Zweig. Shopify
    // verknuepft VERSCHIEDENE Filterarten mit UND, ein filter.p.tag steht also neben den
    // tyre.*-Metafeldfiltern und traegt die XL-Regel in die Trefferliste.
    //
    // Warum das auf dem Kollektions-Weg unschaedlich ist: dort ist die Liste per
    // Konstruktion leer. data-coll haengt an data.sizeExact, und das setzt die App genau
    // dann, wenn die Kaskade JEDE Regel der Seite nachbildet — dann bleibt fuer
    // extraFilters nichts uebrig (dieselbe Pruefung, gespiegelt). Sollte die App das
    // Signal je lockern, ist der Parameter hier ein No-Op statt einer stillen Luecke: die
    // Kollektion erfuellt ihre eigene Regel ohnehin, der Filter kann nur nichts wegnehmen.
    // TAG-ROUTE VOR DER SUCHE. /search ist bei ~1.000 Dokumenten gedeckelt (gemessen
    // 01.09.2026: q=reifen -> 1.002 im Korpus; 205/55 R16 als Winterreifen dort 14
    // Treffer, /collections/winterreifen/205-55-r16 -> 372 von 21.808). Die Tag-Route
    // greift auch OBERHALB der 5.000er-Filtergrenze, zaehlt exakt und wendet die
    // Kollektionsregeln weiter an — Saison, Fahrzeugklasse und der Preistipps-Deckel
    // stecken in der Kollektion selbst, deshalb faehrt hier KEIN Filterparameter mit.
    //
    // Drei Riegel, jeder einzeln noetig:
    //   * GENAU EINE gedruckte Form fuer dieses Blatt. 130/90-16 existiert als
    //     130-90-16, 130-90-b16 UND 130-90-r16 — bei Mehrdeutigkeit landete ein
    //     Drittel der Kunden auf der duennsten Form. Dann lieber /search.
    //   * KEINE extraFilters. Eine Kennungs-Seite (Extra Load) haelt ihre Regel zwar
    //     auch auf der Tag-Route, aber der Baum kennt die Kennung nicht — eine
    //     Groesse ohne XL-Ausfuehrung endete dort auf 0 Treffern. /search traegt die
    //     Kennung wenigstens als Filter.
    //   * data-coll gewinnt: unter der Grenze rendert die Kollektion echte Facetten
    //     zur Weiterverengung, das ist mehr als die nackte Tag-Ansicht.
    //
    // GEMERKT wird trotzdem die Such-URL (writeLastSize unten liest sie): der Chip
    // 'Zuletzt gesucht' auf der Startseite darf nicht dauerhaft in dieser Kategorie
    // haengen bleiben — dieselbe Begruendung wie bei den extraFilters darunter.
    var leafKey = selW.value + '|' + (selA.value === NO_ASPECT ? '-' : selA.value) + '|' + selD.value;
    var leafTags = (tree && tree.tags && tree.tags[leafKey]) || [];

    // ZIELFUNKTION ZUERST (assets/ap-size-target.js, Befund finden-groessensuche-
    // zeigt-nur-bruchteil): die App kennt das Ziel mit dem GANZEN Bestand und echten
    // Facetten (Split-Kollektion unter 5.000), das Theme setzt Handles nie selbst
    // zusammen. Gefragt wird nur, wo ihr Ziel die Seite nicht verlaesst:
    //   * data-coll: diese Kollektion filtert schon selbst mit Facetten — bleiben.
    //   * extraFilters: die Seite traegt eine Regel (XL, Werksfreigabe), die die
    //     Route nicht kennt — sie fiele sonst weg.
    //   * data-size-exact fehlt: nur mit der Bestaetigung der App, dass die Seite
    //     ausschliesslich Tag/Saison/Zoll/Fahrzeugklasse verengt, ist ein Ziel
    //     ausserhalb der Kollektion gleichwertig (Preistipps-Deckel, Marken-Seite …).
    // Saison und Fahrzeugklasse der Seite fahren als season/scope mit — die Klasse
    // nur, wo ein scope sie 1:1 abbildet (sizeTargetParams). Ohne Antwort (Route
    // fehlt, Zeitlimit, null) gilt das bisherige Ziel unveraendert.
    var target = sizeTargetParams(coll, aspect);
    if (target) {
      window.apSizeTarget(target).then(
        function (url) {
          if (url) {
            writeLastSize(url);
            window.location.href = url;
            return;
          }
          goCurrentTarget();
        },
        goCurrentTarget
      );
      return;
    }
    goCurrentTarget();

    function goCurrentTarget() {
      if (!coll && tagBase && !extraFilters.length && leafTags.length === 1) {
        writeLastSize('/search?' + p.join('&'));
        window.location.href = tagBase + '/' + leafTags[0];
        return;
      }
      var base = coll || '/search';
      var sep = base.indexOf('?') > -1 ? '&' : '?';
      // GEMERKT wird die Groesse OHNE die Einschraenkung dieser Seite. Der Chip "Zuletzt
      // gesucht" auf der Startseite zeigt nur das Groessen-Label ("205/55 R16") und haengt
      // an dieser URL — traegt sie ein filter.p.tag=Extra%20Load, bliebe die Startseiten-
      // Suche dauerhaft auf XL verengt, ohne dass es irgendwo steht. Saison und
      // Fahrzeugklasse sind schon vorher mitgewandert und breit genug, um sichtbar zu
      // bleiben; eine Kennung schneidet die Liste um eine Groessenordnung.
      writeLastSize(base + sep + p.join('&'));
      window.location.href = base + sep + p.concat(extraFilters).join('&');
    }
  });

  // Parameter fuer window.apSizeTarget — oder null, wenn diese Seite nicht fragen
  // darf (Begruendung am Aufruf). Ohne Fahrzeugklasse (Saison-Seite ueber alle
  // Klassen) gilt scope 'auto': dort sucht fast jeder einen PKW-Reifen, und ein
  // Blatt, das es in auto nicht gibt, beantwortet die Route mit null — dann bleibt
  // es bei der Tag-Route der Seite.
  //
  // MIT Fahrzeugklasse nur, wenn der scope genau diese Produktart meint
  // (exactScopeFor in ap-size-target.js): das bisherige Ziel dieser Seite — die
  // Tag-Route der Kollektion bzw. /search mit filter.p.product_type — bleibt in
  // ihrer Klasse. 'auto' fasst PKW, SUV, Transporter und Oldtimer zusammen; auf
  // einer PKW-Kollektion ersetzte sein Ziel die Tag-Route und mischte die
  // Klassen (Nachpruefung 25.09.2026). Bis die Route eine Produktart kennt,
  // fragen solche Seiten gar nicht.
  function sizeTargetParams(coll, aspect) {
    var ask = window.apSizeTarget;
    if (typeof ask !== 'function') return null;
    if (coll || extraFilters.length || !form.hasAttribute('data-size-exact')) return null;
    var scope = vehicleType ? (typeof ask.exactScopeFor === 'function' ? ask.exactScopeFor(vehicleType) : null) : 'auto';
    if (!scope) return null;
    return { kind: 'tyre', scope: scope, w: selW.value, a: aspect, r: selD.value, season: season };
  }

  var url = form.getAttribute('data-proxy');
  if (!url) {
    form.hidden = true; // kein Proxy: nichts zu fuellen, den reservierten Platz freigeben
    return;
  }
  // Die Fahrzeugklasse der Seite mitgeben: der Proxy liefert dann nur Größen, die es in
  // DIESER Kategorie gibt. Ohne das stand auf einer PKW-Seite die Implement-Breite 22
  // zur Wahl (139 statt 42 Breiten) und der Klick lief ins Leere.
  //
  // VERBLEIBENDE UNSCHÄRFE, bewusst stehen gelassen: der BAUM lässt sich nur über die
  // Fahrzeugklasse verengen. Der Proxy nimmt ausser `type` bloss `scope` entgegen (eine
  // Gruppe von Produktarten) — eine Tag-Verengung gibt es dort NICHT, und sie wäre auch
  // nicht billig nachzurüsten: der Baum entsteht aus CatalogProduct-Spalten (Breite,
  // Querschnitt, Zoll, Saison, Klasse), Flankenkennungen stehen in keiner davon, und je
  // Kennung ein eigener Cache-Schlüssel vervielfachte die gecachten Bäume (siehe
  // available-sizes.server.ts).
  //
  // Folge auf einer Kennungs-Seite OHNE Fahrzeugklasse (xl-reifen-extra-load-17-zoll trägt
  // keine TYPE-Regel): der Baum ist dort nur über data-rim-diameter verengt und kann eine
  // Breite anbieten, die es in 17 Zoll zwar gibt, aber nicht als XL-PKW-Reifen. Was der
  // Kunde danach zu sehen bekommt, ist durch die Zusatzfilter oben KORREKT gefiltert —
  // falsche Treffer sind ausgeschlossen, eine leere Liste nicht.
  var vt = form.getAttribute('data-vehicle-type');
  if (vt) url += (url.indexOf('?') === -1 ? '?' : '&') + 'type=' + encodeURIComponent(vt);
  // na=1 nimmt die Groessen OHNE Querschnitt mit in den Baum (Schluessel NO_ASPECT).
  // Ohne den Parameter laesst die Abfrage in available-sizes.server.ts sie per
  // "aspectRatio IS NOT NULL" fallen — lautlos, ohne Fehler, ohne Log, und die Kaskade
  // sah einfach nach einem kleineren Sortiment aus. Live gemessen 2026-09-01 am Proxy:
  // Agrarreifen 604 -> 813 Groessen (209 davon ohne Querschnitt, 26 %) und 134 -> 170
  // Breiten; Breiten wie 11.2 gibt es AUSSCHLIESSLICH so. Der Baum mit na haengt an
  // einem eigenen Cache-Schluessel, der bisherige bleibt Byte-fuer-Byte unberuehrt.
  url += (url.indexOf('?') === -1 ? '?' : '&') + 'na=1';
  // Pro URL genau ein Abruf, auch wenn mehrere Blöcke derselben Seite fragen.
  window.__apSizeTrees = window.__apSizeTrees || {};
  window.__apSizeTrees[url] = window.__apSizeTrees[url] ||
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  window.__apSizeTrees[url].then(function (t) {
    // Ohne Daten verschwindet sie (R2: der Platz war reserviert, data-ap-warten).
    if (!t || !t.widths || !t.widths.length) {
      form.hidden = true;
      return;
    }
    tree = t;
    var widths = t.widths.filter(function (w) {
      var byA = t.tree[w] || {};
      return Object.keys(byA).some(function (a) {
        return Object.keys(byA[a]).some(function (d) { return sizeOk(d, byA[a][d]); });
      });
    });
    if (!widths.length) {
      form.hidden = true;
      return;
    }
    fill(selW, widths, PICK);
    refreshAspects();
    refreshDiameters();
    applyLastSize();
    updateGo();
    form.removeAttribute('data-ap-warten');
    form.hidden = false;
  });
})();
